<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Upload CSV file">
            <b-form @submit.prevent="onSubmit" @reset="onReset">
            <b-form-file
                v-model="file"
                :state="Boolean(file)"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here...">
            </b-form-file>
            <b-form-group v-if="!disabled" class="mt-3">Selected file: {{ file ? file.name : '' }}</b-form-group>
            <b-form-group>
                <b-button type="submit" :disabled="disabled" variant="primary">Upload</b-button>
                <b-button type="reset" variant="danger">Reset</b-button>
            </b-form-group>
            <b-form-group>
              <transition name="slide-fade" mode="in-out">
                <b-alert v-if="uploaded" show variant="success">{{ file.name }} uploaded!</b-alert>
              </transition>
            </b-form-group>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card header="Affiliate codes">
            <div class="filter-bar ui basic segment grid">
              <div class="ui form">
                <div class="inline field">
                  <label>Search for:</label>
                  <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="code, description, bookmaker">
                  <button class="ui primary button" @click="doFilter">Go</button>
                  <button class="ui button" @click="resetFilter">Reset</button>
                </div>
              </div>
            </div>
            <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions">
              <template slot="actions" slot-scope="props">
                <div class="table-button-container">
                  <button class="btn btn-info" @click="editAffiliate(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
                  <button class="btn btn-danger" @click="deleteAffiliate(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
                </div>
              </template>
            </vuetable>
            <div class="vuetable-pagination ui basic segment grid">
              <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
              <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card header="Add a new affiliate">
            <form action="#" method="POST" class="createAffiliate">
              <div class="form-group">
                <label >Affiliate Code:</label>
                <input class="form-control" type="text" placeholder="Ex: 325_200" required="required" v-model="affCode">
              </div>
              <div class="form-group">
                <label for="#bookmaker" class="text-info">Select the Bookmaker</label>
                <select id="bookmaker" class="form-control" name="bookmaker" v-model="affBookmaker" @change="addANewBookmaker">
                  <option value="0">Select</option>
                  <option v-for="bookmaker in bookmakers" :key="bookmaker._id" :value="bookmaker.code">{{bookmaker.name}}</option>
                  <option class="special" value="addnew">Add a new Bookmaker</option>
                </select>
              </div>
              <div class="form-group">
                <label for="#cmpDescription">Affiliate Description:</label>
                <textarea class="form-control" id="cmpDescription" v-model="affDescription"></textarea>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="default" v-model="affDefault">
                <label class="form-check-label" for="default">Default code</label>
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveAffiliate">Save</button>
              </div>
            </form>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <add-a-new-bookmaker></add-a-new-bookmaker>
    <edit-affiliate-modal></edit-affiliate-modal>
    <csv-modal></csv-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import { Bus } from '@/main'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import collect from 'collect.js'
import AddBookmakerModal from '@/views/modals/AddBookmakerModal'
import EditAffiliateModal from '@/views/modals/EditAffiliateModal'
import CSVModal from '@/views/modals/CSVModal'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    'add-a-new-bookmaker': AddBookmakerModal,
    'edit-affiliate-modal': EditAffiliateModal,
    'csv-modal': CSVModal

  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      affcodes: [],
      affDefault: '',
      affCode: '',
      affDescription: '',
      affBookmaker: 0,
      bookmakers: [],
      moreParams: {},
      filterText: '',
      file: null,
      filename: null,
      disabled: false,
      uploaded: false,
      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'affcode',
          title: 'Affiliate Code',
          sortField: 'affcode'
        },
        {
          name: 'bookmaker',
          title: 'Bookmaker',
          sortField: 'bookmaker',
          callback: 'getBookmakerNameByCode'
        },
        {
          name: 'description',
          title: 'Description'
        },
        {
          name: 'default',
          title: 'Default',
          sortField: 'default',
          callback: 'formatIsDefault',
          dataClass: 'center aligned'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      if (this.file) {
        // Initialize the form data
        const formData = new FormData()
        /*
          Add the form data we need to submit
        */
        formData.append('file', this.file)
        this.$http.post(`${this.$api_url}/affcodes/uploadCSV`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then((data) => {
          this.uploaded = true
          this.processCSVFile(data.data.filename)
          const uploadSuccess = setTimeout(() => {
            this.onReset()
            clearTimeout(uploadSuccess)
          }, 3000)
        })
      }
    },

    deleteCSVFile () {
      const formData = new FormData()
      formData.append('file', this.filename)
      this.$http.post(`${this.$api_url}/affcodes/deleteCSV`, formData).then(data => {

      })
      this.filename = null
    },

    processCSVFile (filename) {
      this.filename = filename
      const formData = new FormData()
      formData.append('file', filename)
      this.$http.post(`${this.$api_url}/affcodes/processCSV`,
        formData).then(data => {
        // console.log(data.data)
        // emit data to the modal
        this.$bvModal.show('csv-import')
        Bus.$emit('csvData', data.data.data)
      }).catch(err => {
        alert('Error while processing ' + filename, err)
      })
    },
    onReset () {
      // Reset our form values
      this.file = null
      this.disabled = false
      this.uploaded = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatActions (value) {
      return `<i ref="delete_${value}" @click="console.log('test')" class="fas fa-trash-alt"></i>`
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    getBookmakerNameByCode (value) {
      const bkm = collect(this.bookmakers)

      const bookmaker = bkm.where('code', parseInt(value)).first()

      return typeof bookmaker !== 'undefined' ? bookmaker.name : '-'
    },
    getBookmakers () {
      this.$http.get(`${this.$api_url}/bookmakers/all`).then((bookmakers) => {
        this.bookmakers = bookmakers.data
      })
    },
    formatIsDefault (value) {
      return (!value)
        ? ''
        : '<i class="fas fa-check-square"></i>'
    },
    saveAffiliate () {
      if (this.affCode && this.affDescription && this.affBookmaker) {
        this.$http.post(`${this.$api_url}/affcodes/create`, { bookmaker: this.affBookmaker.toString(), code: this.affCode, description: this.affDescription, default: this.affDefault }).then((success, error) => {
          if (success) {
            this.reloadTable()
            this.affDescription = ''
            this.affName = ''
            this.affCode = ''
            this.affDefault = ''
            this.affBookmaker = 0
          }
          if (error) {
            alert('Duplicate Affiliate code!')
          }
        })
      }
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteAffiliate (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/affcodes/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('Affiliate code deleted!')
        })
      } else {
        alert('Affiliate code not deleted!')
      }
    },
    addANewBookmaker (event) {
      if (event.target.value === 'addnew') {
        Bus.$emit('modalBookmakersOpened')
        this.$bvModal.show('bookmaker-add')
      }
    },
    editAffiliate (data) {
      Bus.$emit('editAffiliate', data)
      this.$bvModal.show('affiliate-edit')
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.filterText = ''
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    }
  },
  created () {
    this.api_url = `${this.$api_url}/affcodes`
    this.getBookmakers()
    Bus.$on('reloadBookmakers', (data) => {
      this.getBookmakers()
      this.affBookmaker = data.code
    })
    Bus.$on('affiliateUpdated', () => {
      this.getBookmakers()
      this.reloadTable()
    })
    Bus.$on('csvDataImported', () => {
      this.deleteCSVFile()
      this.reloadTable()
    })
  },
  beforeDestroy () {
    Bus.$off('reloadBookmakers')
    Bus.$off('affiliateUpdated')
    Bus.$off('csvDataImported')
  }
}
</script>

<style scoped>

</style>
